import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

import logo_color from '../../img/gpViewer_LOGO_4-pomarancz.png';
import {colors} from '../../helpers/colors';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 5,
    color: colors.barBackgroundDark,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff'
  },
  logo: {}
}));

export const Loader = React.memo(() => {
  const classes = useStyles();

  return (
    <div>
      <Backdrop 
        id="logo-backdrop"
        className={classes.backdrop} 
        open={true}
      >
        <img className={classes.logo} src={logo_color} alt="gpViewer logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
})